<div class="pt-3" *ngIf="privateEventNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="mt-3 alert alert-danger" *ngIf="missingPermission">
  You need the "Can manage events" permission in order to manage this private event.
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!privateEventNotFound && (serverError === null) && !missingPermission">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="!privateEvent">LOADING PRIVATE EVENT...</span>
        <span *ngIf="privateEvent">EDIT PRIVATE EVENT: {{ privateEvent.event_type_name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-3 border-rounded-10">

    <app-private-event-setup-nav [loadingEvent]="loadingPrivateEvent"
                                 [privateEvent]="privateEvent"></app-private-event-setup-nav>

    <div class="m-4" *ngIf="loadingPrivateEvent || loadingPricingMatrix || loadingEventQuestions || loadingBooking || loadingRequestBooking">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <form (submit)="save()" class="m-4" *ngIf="!(loadingPrivateEvent || loadingPricingMatrix || loadingEventQuestions || loadingBooking || loadingRequestBooking)">

      <ng-container *ngIf="requestBooking">

        <button class="btn btn-sm btn-outline-primary"
                type="button" (click)="showRequestBooking = !showRequestBooking">
          {{ showRequestBooking ? 'Hide Request Booking Info' : 'Show Request Booking Info' }}
        </button>

        <div *ngIf="showRequestBooking" class="mt-2">

          <div class="mb-2">
            Booked By:
            <span *ngIf="!requestBooking.booked_by_customer_id"
                  class="text-muted">
              Non-Logged In Customer
            </span>
            <a *ngIf="requestBooking.booked_by_customer_id"
               routerLink="/customers/{{ requestBooking.booked_by_customer_id }}">
              {{ requestBooking.booked_by_customer_first_name }}
              {{ requestBooking.booked_by_customer_last_name }}
            </a>

            <br>

            Booking Completed At:
            <b>
              {{ dateStringFromISO8601(requestBooking.purchase_completed_at, requestBooking.location_time_zone) }},
              {{ timeStringFromISO8601(requestBooking.purchase_completed_at, requestBooking.location_time_zone) }}
            </b>
          </div>

          <div class="mb-2">
            Request Event Type:
            <b>{{ requestBooking.event_type_name }}</b>

            <br>

            Requested Time Slot:
            <b>
              {{ dateStringFromISO8601(requestBooking.event_parts[0].event_start_datetime, requestBooking.location_time_zone) }},
              {{ timeStringFromISO8601(requestBooking.event_parts[0].event_start_datetime, requestBooking.location_time_zone) }}
            </b>

            <br>

            Requested Location:
            <b>
              {{ requestBooking.location_name }}
            </b>
            <small class="text-muted d-block">
              This time slot and location have been prefilled below.
            </small>
          </div>

          <div class="mb-2" *ngIf="isNewBooking">
            Amount Paid:
            <b>
              {{ orgConfigService.formatCurrency(requestBooking.unrefunded_currency_amount) }}
            </b>
            <small class="text-muted d-block"
                   *ngIf="requestBooking.unrefunded_currency_amount > 0">
              This payment will be applied towards the private event's fee once it is created.
            </small>
          </div>

          <div class="mb-2" *ngFor="let questionName of Object.keys(requestBooking.question_responses)">
            {{ questionName }}{{ !['.', '?'].includes(questionName.slice(-1)) ? ':' : '' }}
            <b>
              <ng-container *ngIf="propExistsAndIsNonEmpty(requestBooking.question_responses[questionName])">
                {{ requestBooking.question_responses[questionName] }}
              </ng-container>
              <span class="text-muted"
                    *ngIf="!propExistsAndIsNonEmpty(requestBooking.question_responses[questionName])">
                No response
              </span>
            </b>
          </div>

        </div>

        <div class="alert alert-danger mt-2"
             *ngIf="errors.request_booking_id">
          {{ errors.request_booking_id }}
        </div>

        <hr>

      </ng-container>

      <div class="row">
        <!-- Put a copy of the save buttons at the top so users don't have to scroll if they just want to enter the -->
        <!-- booking customer and number of participants. -->
        <div class="col-lg-6 order-lg-2 mb-3">
          <!-- Place save button first so that the enter key press activates it -->
          <div class="float-right">
            <!-- Invisible button causes the "enter" keypress to be of submit type continue. -->
            <button type="submit" style="display: none"
                    [disabled]="loadingSave"
                    (click)="submitType=SUBMIT_TYPE_CONTINUE"></button>
            <button type="submit" class="btn btn-primary mr-2"
                    [disabled]="loadingSave" [class.disabled]="loadingSave"
                    (click)="submitType=SUBMIT_TYPE_GO_BACK">
              Save and Go Back
            </button>
            <button type="submit" class="btn btn-primary"
                    [disabled]="loadingSave" [class.disabled]="loadingSave"
                    (click)="submitType=SUBMIT_TYPE_CONTINUE">
              Save and Continue
            </button>
          </div>
        </div>
        <div class="col-lg-6 order-lg-1 mb-3">
          <p class="mb-1">
            Booking Customer Name:
            <a *ngIf="booking.booked_by_id"
               href="#" target="_blank"
               [routerLink]="'/customers/' + booking.booked_by_id.toString()">
              {{ booking.booked_by_first_name }} {{ booking.booked_by_last_name }}
            </a>
            <span *ngIf="!booking.booked_by_id" class="text-muted">None Selected</span>
            <br>
            Booking Customer Email:
            <b *ngIf="booking.booked_by_email">
              {{ booking.booked_by_email }}
            </b>
            <span *ngIf="!booking.booked_by_id" class="text-muted">None</span>
          </p>

          <div class="d-block clearfix">
            <button class="btn btn-primary btn-sm" type="button"
                    (click)="openSelectBookingCustomer()">
              Select Customer
            </button>
            <button class="btn btn-primary btn-sm ml-2" type="button"
                    (click)="openCreateNewBookingCustomer()">
              Create New Customer
            </button>
          </div>

          <small class="form-text text-muted">
            The booking customer is the customer who owns the booking. The booking will appear in their Climber App, and any payment receipt emails will be sent to them.
          </small>

          <div class="form-text text-danger">
            {{ errors.booked_by_id }}
          </div>
        </div>
      </div>

      <div class="d-block clearfix mb-3" *ngIf="pricingMatrix && (pricingMatrix.per_booking_fees.length > 0)">
        <span>Booking Fee</span>
        <div class="form-check ml-2" *ngFor="let fee of pricingMatrix.per_booking_fees">
          <input class="form-check-input" type="radio"
                 [name]="'booking_payment_fee_name ' + fee.name"
                 [id]="'booking_payment_fee_name ' + fee.name"
                 [value]="fee.name"
                 [(ngModel)]="booking.payment_fee_name"
                 (ngModelChange)="unsavedChanges = true">
          <label class="form-check-label"
                 [for]="'booking_payment_fee_name ' + fee.name">
            {{ fee.name }}
            <ng-container *ngIf="fee.included_participants">
              <ng-container *ngIf="fee.additional_participant_fee">
                ({{ orgConfigService.getCurrencySymbol() }}{{ fee.fee }} for up to {{ fee.included_participants }}, {{ orgConfigService.getCurrencySymbol() }}{{ fee.additional_participant_fee }} for each additional participant)
              </ng-container>
              <ng-container *ngIf="!fee.additional_participant_fee">
                ({{ orgConfigService.getCurrencySymbol() }}{{ fee.fee }} for up to {{ fee.included_participants }} participants)
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!fee.included_participants">
              ({{ orgConfigService.getCurrencySymbol() }}{{ fee.fee }})
            </ng-container>
          </label>
        </div>
      </div>

      <div class="d-block clearfix mb-3" *ngIf="pricingMatrix && (pricingMatrix.per_booking_add_ons.length > 0)">
        <span>Booking Add-Ons</span>
        <div class="form-check ml-2" *ngFor="let addOn of pricingMatrix.per_booking_add_ons">
          <input class="form-check-input" type="checkbox"
                 [name]="'booking_add_on_name ' + addOn.name"
                 [id]="'booking_add_on_name ' + addOn.name"
                 [checked]="booking.add_on_names.includes(addOn.name)"
                 (change)="toggleAddOn(booking.add_on_names, addOn.name)">
          <label class="form-check-label"
                 [for]="'booking_add_on_name ' + addOn.name">
            {{ addOn.name }}
            <ng-container *ngIf="addOn.included_participants">
              <ng-container *ngIf="addOn.additional_participant_fee">
                ({{ orgConfigService.getCurrencySymbol() }}{{ addOn.fee }} for up to {{ addOn.included_participants }}, {{ orgConfigService.getCurrencySymbol() }}{{ addOn.additional_participant_fee }} for each additional participant)
              </ng-container>
              <ng-container *ngIf="!addOn.additional_participant_fee">
                ({{ orgConfigService.getCurrencySymbol() }}{{ addOn.fee }} for up to {{ addOn.included_participants }} participants)
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!addOn.included_participants">
              ({{ orgConfigService.getCurrencySymbol() }}{{ addOn.fee }})
            </ng-container>
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <label>Discount Amount</label>
        <div class="row">
          <div class="col-lg-6">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
              </div>
              <input class="form-control" name="discount_amount"
                     type="number" min="0" step="0.01"
                     [(ngModel)]="booking.discount_amount"
                     (ngModelChange)="unsavedChanges = true">
            </div>
            <small class="form-text text-muted">
              The discount is applied to the total cost of the booking.
            </small>
          </div>
        </div>
        <div class="form-text text-danger">
          {{ errors.discount_amount }}
        </div>
      </div>

      <div class="form-group mb-4">
        <label>Number of Participants</label>
        <div class="row">
          <div class="col-6">
            <input class="form-control" name="numReservations"
                    [(ngModel)]="numReservations"
                    (ngModelChange)="handleNumReservationsChange()">
          </div>
        </div>
        <div class="form-text text-danger">
          {{ errors.numReservations }}
        </div>
      </div>

      <div class="mb-3" *ngIf="numReservations > 0">
        <button class="btn btn-outline-primary btn-sm" type="button"
                (click)="openAddParticipant()">
          Add Participant
        </button>
      </div>

      <ng-container *ngIf="(numReservations !== null) && (numReservations !== undefined)">
        <div class="mb-3"
             *ngFor="let reservation of booking.reservations.slice(0, numReservations); let resIdx = index;">

          <p class="mb-1">
            Participant #{{ resIdx + 1 }}:
            <ng-container *ngIf="reservation.customer_id">
              <a href="#" target="_blank"
                 [routerLink]="'/customers/' + reservation.customer_id.toString()">
                {{ reservation.first_name }} {{ reservation.last_name }}
              </a>
              (<span class="text-danger cursor-pointer underline-on-hover" (click)="clearReservationCustomer(reservation)">Remove</span>)
            </ng-container>
            <ng-container *ngIf="!reservation.customer_id">
              <ng-container *ngIf="(reservation.first_name + reservation.last_name) !== ''">
                {{ reservation.first_name }} {{ reservation.last_name }}
                (<span class="text-danger cursor-pointer underline-on-hover" (click)="clearReservationCustomer(reservation)">Remove</span>)
              </ng-container>
              <span *ngIf="(reservation.first_name + reservation.last_name) === ''"
                    class="text-muted">
                None Selected
              </span>
            </ng-container>

            <ng-container *ngIf="reservation.customer_id">
              <br>
              Gym Status: <b>{{ getCustomerGymStatus(reservation.customer_id) }}</b>
            </ng-container>
            <ng-container *ngIf="!reservation.customer_id && ((reservation.first_name + reservation.last_name) !== '')">
              <br>
              Gym Status: <b>Unlinked</b>
              <ng-container *ngIf="!loadingUnlinkedReservation">
                (<a href="#" (click)="openReviewUnlinkedReservationModal(reservation);$event.preventDefault()">Link</a>)
              </ng-container>
              <ng-container *ngIf="loadingUnlinkedReservation">
                (<span class="text-muted">Loading...</span>)
              </ng-container>
            </ng-container>
          </p>

          <div class="d-block clearfix" *ngIf="!reservation.customer_id && ((reservation.first_name + reservation.last_name) === '')">
            <button class="btn btn-primary btn-sm" type="button"
                    (click)="openSelectReservationCustomer(resIdx)">
              Select Customer
            </button>
            <button class="btn btn-primary btn-sm ml-2" type="button"
                    (click)="openCreateNewReservationCustomer(resIdx)">
              Create New Customer
            </button>
          </div>

          <div class="d-block mb-2" *ngIf="reservation.customer_id">
            <span *ngIf="reservation.confirmation_email_sent" class="text-primary">
              Confirmation email sent
            </span>
            <div *ngIf="!reservation.confirmation_email_sent" class="form-check">
              <input type="checkbox" class="form-check-input"
                     [id]="'send-email-' + resIdx.toString()"
                     [name]="'send-email-' + resIdx.toString()"
                     [(ngModel)]="reservation.send_confirmation_email"
                     (ngModelChange)="unsavedChanges = true">
              <label class="form-check-label"
                     [for]="'send-email-' + resIdx.toString()">
                Send confirmation email
              </label>
            </div>
          </div>

          <div class="row" *ngFor="let question of participantQuestions">
            <div class="col-md-8 col-xl-6">

              <div class="mt-2" *ngIf="question.question_type === EventQuestionType.singleLineText">
                <label [for]="'question-' + resIdx.toString() + '-' + question.id.toString()">
                  <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                  <span *ngIf="question.is_required">&nbsp;*</span>
                </label>
                <input type="text" class="form-control"
                       [id]="'question-' + resIdx.toString() + '-' + question.id.toString()"
                       [name]="'question-' + resIdx.toString() + '-' + question.id.toString()"
                       [(ngModel)]="reservation.question_responses[question.name]"
                       (ngModelChange)="unsavedChanges = true">
                <small class="form-text text-muted"
                       *ngIf="question.description"
                       [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
              </div>

              <div class="mt-2" *ngIf="question.question_type === EventQuestionType.multipleLineText">
                <label [for]="'question-' + resIdx.toString() + '-' + question.id.toString()">
                  <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                  <span *ngIf="question.is_required">&nbsp;*</span>
                </label>
                <textarea class="form-control"
                          [id]="'question-' + resIdx.toString() + '-' + question.id.toString()"
                          [name]="'question-' + resIdx.toString() + '-' + question.id.toString()"
                          [(ngModel)]="reservation.question_responses[question.name]"
                          (ngModelChange)="unsavedChanges = true"></textarea>
                <small class="form-text text-muted"
                       *ngIf="question.description"
                       [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
              </div>

              <div class="mt-2" *ngIf="question.question_type === EventQuestionType.multipleChoice">
                <label class="mb-1">
                  <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                  <span *ngIf="question.is_required">&nbsp;*</span>
                </label>
                <div class="form-check" *ngFor="let option of question.options.split(','); let optionIdx = index;">
                  <input class="form-check-input" type="radio" name="{{ question.id }}"
                         [id]="'question-' + resIdx.toString() + '-' + question.id.toString() + '-' + optionIdx.toString()"
                         [name]="'question-' + resIdx.toString() + '-' + question.id.toString() + '-' + optionIdx.toString()"
                         [value]="option"
                         [(ngModel)]="reservation.question_responses[question.name]"
                         (ngModelChange)="unsavedChanges = true">
                  <label class="form-check-label"
                         [for]="'question-' + resIdx.toString() + '-' + question.id.toString() + '-' + optionIdx.toString()">
                    {{ option }}
                  </label>
                </div>
                <small class="form-text text-muted"
                       *ngIf="question.description"
                       [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
              </div>

              <div class="mt-2" *ngIf="question.question_type === EventQuestionType.singleCheckbox">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input"
                         [id]="'question-' + resIdx.toString() + '-' + question.id.toString()"
                         [checked]="singleCheckboxChecked(reservation.question_responses, question.name)"
                         (change)="toggleSingleCheckbox(reservation.question_responses, question.name)">
                  <label class="form-check-label"
                         [for]="'question-' + resIdx.toString() + '-' + question.id.toString()">
                    <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                    <span *ngIf="question.is_required">&nbsp;*</span>
                  </label>
                </div>
                <small class="form-text text-muted"
                       *ngIf="question.description"
                       [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
              </div>

              <div class="mt-2" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
                <label class="mb-1">
                  <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                  <span *ngIf="question.is_required">&nbsp;*</span>
                </label>
                <div class="form-check" *ngFor="let option of question.options.split(','); let optionIdx = index;">
                  <input class="form-check-input" type="checkbox" name="{{ question.id }}"
                         [id]="'question-' + resIdx.toString() + '-' + question.id.toString() + '-' + optionIdx.toString()"
                         [checked]="multiCheckboxChecked(reservation.question_responses, question.name, option)"
                         (change)="toggleMultiCheckbox(reservation.question_responses, question.name, option)">
                  <label class="form-check-label"
                         [for]="'question-' + resIdx.toString() + '-' + question.id.toString() + '-' + optionIdx.toString()">
                    {{ option }}
                  </label>
                </div>
                <small class="form-text text-muted"
                       *ngIf="question.description"
                       [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
              </div>

            </div>
          </div>

          <div class="d-block clearfix mt-2" *ngIf="pricingMatrix && (pricingMatrix.per_participant_fees.length > 0)">
            <span>Fee</span>
            <div class="form-check ml-2" *ngFor="let fee of pricingMatrix.per_participant_fees">
              <input class="form-check-input" type="radio"
                     [name]="'reservation_payment_fee_name_' + resIdx.toString() + ' ' + fee.name"
                     [id]="'reservation_payment_fee_name_' + resIdx.toString() + ' ' + fee.name"
                     [value]="fee.name"
                     [(ngModel)]="reservation.payment_fee_name"
                     (ngModelChange)="unsavedChanges = true">
              <label class="form-check-label"
                     [for]="'reservation_payment_fee_name_' + resIdx.toString() + ' ' + fee.name">
                {{ fee.name }} ({{ orgConfigService.getCurrencySymbol() }}{{ fee.fee }})
              </label>
            </div>
          </div>

          <div class="d-block clearfix mt-2" *ngIf="pricingMatrix && (pricingMatrix.per_participant_add_ons.length > 0)">
            <span>Add-Ons</span>
            <div class="form-check ml-2" *ngFor="let addOn of pricingMatrix.per_participant_add_ons">
              <input class="form-check-input" type="checkbox"
                     [name]="'reservation_add_on_name_' + resIdx.toString() + ' ' + addOn.name"
                     [id]="'reservation_add_on_name_' + resIdx.toString() + ' ' + addOn.name"
                     [checked]="reservation.add_on_names.includes(addOn.name)"
                     (change)="toggleAddOn(reservation.add_on_names, addOn.name)">
              <label class="form-check-label"
                     [for]="'reservation_add_on_name_' + resIdx.toString() + ' ' + addOn.name">
                {{ addOn.name }} ({{ orgConfigService.getCurrencySymbol() }}{{ addOn.fee }})
              </label>
            </div>
          </div>

        </div>
      </ng-container>

      <div class="form-text text-danger">
        {{ errors.reservations }}
      </div>

      <div class="alert alert-danger" role="alert"
           *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert"
           *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-info" role="alert"
           *ngIf="loadingSave">
        Saving...
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <!-- Invisible button causes the "enter" keypress to be of submit type continue. -->
        <button type="submit" style="display: none"
                [disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_CONTINUE"></button>
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="loadingSave" [class.disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_GO_BACK">
          Save and Go Back
        </button>
        <button type="submit" class="btn btn-primary"
                [disabled]="loadingSave" [class.disabled]="loadingSave"
                (click)="submitType=SUBMIT_TYPE_CONTINUE">
          Save and Continue
        </button>
      </div>

      <a class="btn btn-secondary"
         [routerLink]="getBackLink()">
        Back to Event Details
      </a>

    </form>

  </div>

</div>
